import { render, staticRenderFns } from "./Concursos.vue?vue&type=template&id=5fb63438&scoped=true&"
import script from "./concursos.ts?vue&type=script&lang=ts&"
export * from "./concursos.ts?vue&type=script&lang=ts&"
import style0 from "./Concursos.vue?vue&type=style&index=0&id=5fb63438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb63438",
  null
  
)

export default component.exports